module.exports = __webpack_public_path__ + "assets/media/home_bg.663fb41d.mp4";